import { createFileRoute } from '@tanstack/react-router'

import { InvalidLinkState } from '@/widgets/invalid-link-state'

export const Route = createFileRoute('/_dashboard/')({
    component: InvalidLinkState,
})
